import script from "./report2Yxltrz.vue?vue&type=script&setup=true&lang=js"
export * from "./report2Yxltrz.vue?vue&type=script&setup=true&lang=js"

import "./report2Yxltrz.vue?vue&type=style&index=0&id=0e23f75d&lang=less"

const __exports__ = script;

export default __exports__